import {
    ReceiptLookupContentComponent,
    ReceiptLookupFooterComponent,
    ReceiptLookupHeaderComponent,
    ReceiptLookupLayoutComponent,
} from '@kempower-nx-workspace/receipt-lookup-app-core';
import { Route } from '@angular/router';
import {
    ReceiptLookupPageNotFoundComponent,
    pageNotFoundGuard,
    receiptLookupPageRoutes,
} from '@kempower-nx-workspace/receipt-lookup-page';
import { ConfigService, NOT_FOUND_PATH } from '@kempower-nx-workspace/receipt-lookup-environment';
import { inject } from '@angular/core';

export const receiptShellRoutes: Route[] = [
    // Subdomain mode: window.location.hostname = {customerId}.appBaseHostname
    {
        path: '',
        canMatch: [() => inject(ConfigService).isSubDomainMode],
        component: ReceiptLookupLayoutComponent,
        children: [
            {
                path: '',
                component: ReceiptLookupHeaderComponent,
                outlet: 'header',
            },
            {
                path: '',
                component: ReceiptLookupContentComponent,
                children: receiptLookupPageRoutes,
            },
            {
                path: '',
                component: ReceiptLookupFooterComponent,
                outlet: 'footer',
            },
        ],
    },
    // Path param mode: window.location.hostname = appBaseHostname, {customerId} is first path segment
    {
        path: NOT_FOUND_PATH,
        canMatch: [() => inject(ConfigService).isPathParamMode],
        component: ReceiptLookupPageNotFoundComponent,
        data: {
            title: 'Page not found',
        },
    },
    {
        path: ':customerId',
        canMatch: [() => inject(ConfigService).isPathParamMode],
        canActivate: [pageNotFoundGuard],
        data: {
            redirectTo: NOT_FOUND_PATH,
        },
        component: ReceiptLookupLayoutComponent,
        children: [
            {
                path: '',
                component: ReceiptLookupHeaderComponent,
                outlet: 'header',
            },
            {
                path: '',
                component: ReceiptLookupContentComponent,
                children: receiptLookupPageRoutes,
            },
            {
                path: '',
                component: ReceiptLookupFooterComponent,
                outlet: 'footer',
            },
        ],
    },
    {
        path: '',
        canMatch: [() => inject(ConfigService).isPathParamMode],
        canActivate: [pageNotFoundGuard],
        data: {
            redirectTo: NOT_FOUND_PATH,
        },
        pathMatch: 'full',
    },
];
